import { getScrollContainer } from '@theme/scroll-container';

/**
 * Shopify auto-generates section wrapper ids like
 * "shopify-section-template--123456789__my-section-id", prefixing a
 * template-specific string that isn't predictable when a link is authored
 * ahead of time. If a plain "#shopify-section-my-section-id" href doesn't
 * match anything exactly, fall back to matching any element whose id ends
 * with that same suffix.
 */
function findTarget(selector) {
  const target = document.querySelector(selector);
  if (target) return target;

  if (selector.startsWith('#shopify-section-')) {
    const suffix = selector.replace('#shopify-section-', '');
    return document.querySelector(`[id$="${suffix}"]`);
  }

  return null;
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-scroll-to]');
  if (!trigger) return;

  const targetSelector = trigger.getAttribute('data-scroll-to');
  const target = targetSelector && findTarget(targetSelector);
  if (!target) return;

  event.preventDefault();

  const container = getScrollContainer();
  const targetRect = target.getBoundingClientRect();

  // `getBoundingClientRect()` is viewport-relative. For a regular scrollable
  // container (desktop's `.page-wrapper`), that container's own rect stays
  // fixed as its content scrolls, so subtracting it recovers the target's
  // position within the container. But `document.scrollingElement` (mobile)
  // IS the thing that scrolls: its rect top always equals `-scrollTop`, so
  // subtracting it and adding `scrollTop` back double-counts the current
  // scroll position. Handle that case directly instead.
  const offset =
    container === document.scrollingElement
      ? targetRect.top + container.scrollTop
      : targetRect.top - container.getBoundingClientRect().top + container.scrollTop;

  container.scrollTo({ top: offset, behavior: 'smooth' });
});
